import { useState, useRef } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import ShopNav from '../../../components/shopNav/ShopNav';
import Footer from '../../../components/footer/footer';
import NavCategorias from '../../../components/navbar/NavCategorias';
import './RecuperarPasswordForm.css';

const API_URL = import.meta.env.VITE_API_URL;

const RecuperarPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const recaptchaRef = useRef(null);
  const SITE_KEY = '6LcHco8rAAAAALYNxuX2ypmiOPyohdfU2CHJurL6'; // reemplaza con tu clave de sitio reCAPTCHA v2

  const validateEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMsg('');

    if (!email.trim()) {
      setError('El correo es obligatorio.');
      return;
    }

    if (!validateEmail(email)) {
      setError('El correo no es válido.');
      return;
    }

    if (!recaptchaToken) {
      setError('Por favor completa el reCAPTCHA.');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API_URL}/authStore/recuperar-password`, {
        email,
        recaptchaToken,
      });

      setSuccessMsg('Se ha enviado un enlace de recuperacion a tu correo.');
      setEmail('');
      setRecaptchaToken(null);
      recaptchaRef.current.reset();
    } catch (err) {
      console.error(err);
      setError('No se pudo enviar el enlace. Verifica el correo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recover-page">
      <ShopNav />
      <NavCategorias />
      <main className="recover-page-main">
        <section className="recover-page-hero recover-page-elevated-wrap recover-page-elevated-wrap--hero">
          <div className="container recover-page-hero-inner">
            <div className="recover-page-hero-copy">
              <h1 className="display-5">Recupera tu acceso</h1>
              <p className="lead">
                Ingresa tu correo y te enviaremos un enlace seguro para restablecer tu contrasena.
              </p>
            </div>
            <div className="recover-page-hero-logo-wrap" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="recover-page-hero-logo" />
            </div>
          </div>
        </section>

        <section className="container recover-content-wrap">
          <div className="recover-form-shell">
            <div className="recover-form-head text-center">
              <h3 className="recover-form-title">Recuperar contrasena</h3>
              <p className="recover-form-subtitle">Te ayudamos a volver a tu cuenta en minutos.</p>
            </div>

            <form onSubmit={handleSubmit} className="recover-form-body">
              <div className="mb-3">
                <label htmlFor="email" className="form-label recover-form-label">Correo electronico</label>
                <input
                  type="email"
                  className={`form-control recover-input ${error ? 'is-invalid' : successMsg ? 'is-valid' : ''}`}
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {error && <div className="invalid-feedback d-block">{error}</div>}
              </div>

              <div className="recover-recaptcha-wrap mb-3 d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey={SITE_KEY}
                  ref={recaptchaRef}
                  onChange={(token) => setRecaptchaToken(token)}
                />
              </div>

              {successMsg && (
                <div className="alert alert-success text-center recover-server-success" role="alert">
                  {successMsg}
                </div>
              )}

              <button type="submit" className="btn w-100 recover-submit-btn" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar enlace de recuperacion'}
              </button>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default RecuperarPasswordForm;
